import classNames from 'classnames';
import IconSVG from 'components/ui/Icon/IconSVG';
import {TRANSACTIONS_TEXTS_MAPPING} from 'constants/common';
import {createMaps} from 'helpers/common';

import {
    ICardTransactionDetail,
    IFxTransactionDetail,
    IPayoutTransactionDetail,
    Transaction,
    TransactionDetails,
} from 'types/transactions';
import {IPaymentRequest} from 'api/payment-requests';

import {
    AutomationTriggerResponse,
    TriggerType,
} from 'components/pages/NewAutomationPage/types/automation';
import styles from './PaymentTypeCell.module.scss';

export type Types =
    | Transaction['@type']
    | IPayoutTransactionDetail['@type']
    | IFxTransactionDetail['@type']
    | IPaymentRequest['@type']
    | ICardTransactionDetail['@type']
    | TriggerType;

const iconMaps = createMaps<{[key in Types]: React.ReactNode}>({
    PayoutTransaction: <IconSVG name="arrowUpRight" />,
    PayoutTransactionDetail: <IconSVG name="arrowUpRight" />,
    WalletTransaction: <IconSVG name="peerMulti" />,
    FxTransaction: <IconSVG name="exchange" />,
    FxTransactionDetail: <IconSVG name="exchange" />,
    PayinTransaction: <IconSVG name="plus" />,
    FeeTransaction: <IconSVG name="fee" />,
    // TODO missing icon
    PaymentRequest: <></>,
    recurring: <IconSVG name="timeBased" />,
    balance_based: <IconSVG name="transactions" />,
    CardTransaction: <IconSVG name="card" />,
    CardTransactionDetail: <IconSVG name="card" />,
});

export interface IPaymentTypeCellProps {
    transaction?:
        | Transaction
        | TransactionDetails
        | IPaymentRequest
        | AutomationTriggerResponse;
    iconWrapperClassname?: string;
    hideTextOnSm?: boolean;
}

const PaymentTypeCell = ({
    transaction,
    iconWrapperClassname,
    hideTextOnSm,
}: IPaymentTypeCellProps) => {
    if (!transaction) return null;
    return (
        <div className={styles.container}>
            <div
                className={classNames(styles.iconWrapper, iconWrapperClassname)}
            >
                {'@type' in transaction
                    ? iconMaps[transaction['@type'] as keyof typeof iconMaps]
                    : iconMaps[
                          (transaction as AutomationTriggerResponse).type!
                      ]}{' '}
            </div>
            <div className={classNames({[styles.hideOnSm]: hideTextOnSm})}>
                {
                    TRANSACTIONS_TEXTS_MAPPING[
                        // TODO
                        //@ts-ignore
                        (transaction['@type'] ||
                            (transaction as AutomationTriggerResponse)
                                .type) as keyof typeof TRANSACTIONS_TEXTS_MAPPING
                    ]
                }
            </div>
        </div>
    );
};

export default PaymentTypeCell;
